import rq from '@/request'

const resource = 'institutions'

const show = id => rq.get(`${resource}/${id}`)
const get = params => rq.get(`${resource}`, {params})
const search = params => rq.get(`${resource}/search`, {params})
const employeesSearch = params => rq.get(`${resource}/employees/search`, {params})
const getBookmarks = params => rq.get(`${resource}/bookmarks`, {params})
const getFavorites = params => rq.get(`${resource}/favorites`, {params})

export default {
  show,
  get,
  search,
  employeesSearch,
  getBookmarks,
  getFavorites
}



// WEBPACK FOOTER //
// ./src/api/institution.js